// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2Retr","insightsList":"newBusinessInsightsMenu_insightsList__3fqgT","active":"newBusinessInsightsMenu_active__bVx5Q"};